import Repository from './Repository'

export default {
  getTodayReport (filter) {
    return Repository.private().get('/dashboard/users/status/today-report')
  },
  getDailyReport (params) {
    return Repository.private().get(
      '/dashboard/users/status/daily-report',
      {
        params: params
      }
    )
  }
}
